import { _ as e } from "./tslib.es6-7f1b1220.js";
import { c as t, u as o, h as i } from "./lit-element-161a1699.js";
import { p as n, q as s, s as a, c as r } from "./decorators-7e9cd43b.js";
import { c } from "./class-map-31af68b2.js";
import { BaseElement as l } from "./BaseElement.esm.min.js";
import { h } from "./host.styles-cf05db22.js";
import { e as d } from "./event.decorator-98549cbc.js";
import "./interactive-icon.component.esm.min.js";
import "./icon-bar.component.esm.min.js";
const p = t`${o(':host {\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n}\n:host::before, :host::after {\n  bottom: 0;\n  content: "";\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n:host::before {\n  box-shadow: transparent 0 calc(var(--zui-gu) * 0.5) inset;\n}\n:host::after {\n  box-shadow: var(--zui-color-thick-line-default) 0 calc(var(--zui-gu) * -0.5) inset;\n}\n\n:host([use-deprecated-close-behavior][closed]) {\n  display: none;\n}\n\n:host([emphasis=active])::before,\n:host([emphasis=selected])::before {\n  box-shadow: var(--zui-color-thick-line-primary) 0 calc(var(--zui-gu) * 0.5) inset;\n}\n\n:host([hierarchy-level=first]) {\n  background-color: var(--zui-color-first-hierarchy-bg-default-enabled);\n}\n:host([hierarchy-level=first][emphasis=active]) {\n  background-color: var(--zui-color-second-hierarchy-bg-default-enabled);\n}\n\n:host([hierarchy-level=first][emphasis=selected]) {\n  background-color: var(--zui-color-second-hierarchy-bg-default-enabled);\n}\n\n:host([hierarchy-level=second]) {\n  background-color: var(--zui-color-second-hierarchy-bg-default-enabled);\n}\n\n:host([interactive][disabled]) {\n  opacity: var(--zui-disabled-opacity);\n  pointer-events: none;\n}\n:host([interactive][hierarchy-level=first][emphasis=default]:hover) {\n  background-color: var(--zui-color-first-hierarchy-bg-default-hovered);\n}\n:host([interactive][hierarchy-level=first][emphasis=active]:hover), :host([interactive][hierarchy-level=first][emphasis=selected]:hover) {\n  background-color: var(--zui-color-first-hierarchy-bg-active-hovered);\n}\n:host([interactive][hierarchy-level=second][emphasis=default]:hover), :host([interactive][hierarchy-level=second][emphasis=active]:hover), :host([interactive][hierarchy-level=second][emphasis=selected]:hover) {\n  background-color: var(--zui-color-second-hierarchy-bg-default-hovered);\n}\n\n:host([no-bottom-line])::after {\n  box-shadow: transparent 0 calc(var(--zui-gu) * -0.5) inset;\n}\n\n:host([size=xs]) {\n  padding: calc(var(--zui-gu) * 1);\n}\n\n:host([size=s]) {\n  padding: calc(var(--zui-gu) * 2);\n}\n\n:host([size=m]) {\n  padding: calc(var(--zui-gu) * 3);\n}\n\n:host([size=l]) {\n  padding: 0 calc(var(--zui-gu) * 4) calc(var(--zui-gu) * 4);\n}\n:host([size=l]) #box:not(.has-header) {\n  padding-top: calc(var(--zui-gu) * 4);\n}\n\n:host([size=xl]) {\n  padding: calc(var(--zui-gu) * 8) calc(var(--zui-gu) * 10);\n}\n\n#box {\n  width: 100%;\n}\n\n#header {\n  align-items: center;\n  display: none;\n  height: calc(var(--zui-gu) * 9.25);\n  justify-content: space-between;\n}\n:host([size=l]) #box.has-header #header {\n  display: flex;\n}\n\n#headertextcontainer {\n  color: var(--zui-color-text-header, var(--zui-color-gs-120));\n  font: var(--zui-typography-subtitle1);\n}')}`;
let v = class extends l {
  constructor() {
    super(...arguments), this.headerText = "", this.emphasis = "default", this.hierarchyLevel = "first", this.closable = !1, this.closed = !1, this.useDeprecatedCloseBehavior = !1, this.disabled = !1, this.interactive = !1, this.noBottomLine = !1, this.size = this.hasTouch ? "m" : "l", this._hasIcons = !1;
  }
  static get styles() {
    return [h, p];
  }
  emitBoxClosedEvent() {
    return this.dispatchEvent(new CustomEvent("box-closed", {
      cancelable: !0,
      bubbles: !1,
      composed: !1
    }));
  }
  emitCloseEvent() {
    this.dispatchEvent(new CustomEvent("close", {
      bubbles: !1,
      composed: !1,
      cancelable: !1
    }));
  }
  get _hasHeader() {
    var e;
    return (null === (e = this.headerText) || void 0 === e ? void 0 : e.length) > 0 || this._hasIcons || this.closable;
  }
  _handleClose(e) {
    e.stopPropagation(), this.disabled && this.interactive || (this.emitCloseEvent(), this.emitBoxClosedEvent() && this.useDeprecatedCloseBehavior && (console.warn("This behavior will change in the future"), this.closed = !0));
  }
  _onIconSlotChanged() {
    this._hasIcons = this._assignedIconOne.length > 0 || this._assignedIconTwo.length > 0 || this._assignedIconThree.length > 0;
  }
  update(e) {
    super.update(e), e.has("emphasis") && "active" === this.emphasis && console.warn(`Deprecated emphasis: ${this.emphasis} was used on zui-box.`);
  }
  render() {
    return i`<section id="box" class="${c({
      "has-header": this._hasHeader
    })}"><header id="header"><zui-truncate-with-tooltip id="headertextcontainer" tooltip-trigger="hover">${this.headerText}</zui-truncate-with-tooltip><zui-icon-bar @close="${this._handleClose}" id="iconbar" emphasis="${"selected" === this.emphasis ? "highlight" : "subtle"}" ?closable="${this.closable}"><slot name="icon1" slot="icon1" @slotchange="${this._onIconSlotChanged}"></slot><slot name="icon2" slot="icon2" @slotchange="${this._onIconSlotChanged}"></slot><slot name="icon3" slot="icon3" @slotchange="${this._onIconSlotChanged}"></slot></zui-icon-bar></header><zui-scrollable-directive background="visible" hitarea="enlarged"><span id="placeholder"><slot id="content"></slot></span></zui-scrollable-directive></section>`;
  }
};
e([n({
  reflect: !0,
  type: String,
  attribute: "header-text"
})], v.prototype, "headerText", void 0), e([n({
  reflect: !0,
  type: String
})], v.prototype, "emphasis", void 0), e([n({
  reflect: !0,
  type: String,
  attribute: "hierarchy-level"
})], v.prototype, "hierarchyLevel", void 0), e([n({
  reflect: !0,
  type: Boolean
})], v.prototype, "closable", void 0), e([n({
  reflect: !0,
  type: Boolean
})], v.prototype, "closed", void 0), e([n({
  reflect: !0,
  type: Boolean,
  attribute: "use-deprecated-close-behavior"
})], v.prototype, "useDeprecatedCloseBehavior", void 0), e([n({
  reflect: !0,
  type: Boolean
})], v.prototype, "disabled", void 0), e([n({
  reflect: !0,
  type: Boolean
})], v.prototype, "interactive", void 0), e([n({
  reflect: !0,
  type: Boolean,
  attribute: "no-bottom-line"
})], v.prototype, "noBottomLine", void 0), e([n({
  reflect: !0,
  type: String
})], v.prototype, "size", void 0), e([d()], v.prototype, "emitBoxClosedEvent", null), e([d()], v.prototype, "emitCloseEvent", null), e([s("icon1", !0, "[zuiIcon]")], v.prototype, "_assignedIconOne", void 0), e([s("icon2", !0, "[zuiIcon]")], v.prototype, "_assignedIconTwo", void 0), e([s("icon3", !0, "[zuiIcon]")], v.prototype, "_assignedIconThree", void 0), e([a()], v.prototype, "_hasIcons", void 0), v = e([r("zui-box")], v);
export { v as Box };
